export enum SortEnum {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = ''
}

export interface Sort {
  [sortBy: string]: SortEnum;
}
